// @flow
import * as React from 'react'
import Frameworks from './frameworks'
import type { FrameworkType } from './frameworks'
import type { SelectFrameworkBarType } from '../reducers/select_framework_bar'
import type { CollaborationSettingsType } from '../reducers/collaboration_settings'
import type { CollaborationType } from '../reducers/collaboration'
import type { SettingsBarType } from '../reducers/settings'

type Props = {
    collaboration: CollaborationType,
    collaborationSettings: CollaborationSettingsType,
    frameworks: FrameworkType[],
    fetchFrameworks: Function,
    ficus: SelectFrameworkBarType,
    handledSelectFramework: Function,
    setFicusData: Function,
    settings: SettingsBarType,
    theme: {},
    visible: boolean,
}

function SelectFrameworkBar(props: Props) {
    const theme = props.theme
    const rootClassNames = [theme.controlBar]
    if (!props.visible) rootClassNames.push(theme.hidden)

    return (
        <div className={rootClassNames.join(' ')} style={{ zIndex: 199, overflow: 'visible !important' }}>
            <div className={theme.controlBarTop} >
                <Frameworks
                    {...props}
                />
            </div>
        </div>
    )
}

SelectFrameworkBar.defaultProps = {
    ficusData: undefined,
}

export default SelectFrameworkBar
